'use client';

import { BackgroundVideo } from './background-video';
import { SelfHostedPlayer } from './selfhosted-player';
import { YouTubePlayer } from './youtube-player';
import type { SmartVideoProps } from './smart-video.types';

export type { SmartVideoProps, SmartVideoType } from './smart-video.types';

export function SmartVideo(props: SmartVideoProps) {
  const { type = 'background' } = props;

  switch (type) {
    case 'youtube':
      return <YouTubePlayer {...props} />;
    case 'video':
      return <SelfHostedPlayer {...props} />;
    case 'background':
    default:
      return <BackgroundVideo {...props} />;
  }
}
